import {useStore} from 'vuex'

export default {
    name: "FrivilligjobAside",
    props: {
        jobId: {
            type: String,
            required: true
        },
        redirectAfterDeleteUrl: {
            type: String,
            required: false
        }
    },
    setup(props) {
        const store = useStore()
        const openDeleteOverlay = function (e) {
            if (!props.jobId) return false
            
            store.commit('main/set_page_overlay_content_data', {
                frivilligjobId: props.jobId,
                redirectAfterDeleteUrl: props.redirectAfterDeleteUrl
            })

            store.dispatch('main/openPageOverlay', {
                overlayContent: 'DeleteFrivilligjobOverlay',
                returnTarget: e.currentTarget
            })
        }

        return {
            openDeleteOverlay
        }
    }
}